import { POPUPS } from '@/js/AppState';
import Popup from '@cmp/shared/Popup/Popup';
import Tabs from '@cmp/shared/Tabs/Tabs';
import { useEffect, useState } from 'react';
import PopupsManager from 'react-sdk/PopupsManager';
import PagePlayerLeaderboard from './PagePlayerLeaderboard';
import PageTeamLeaderboard from './PageTeamLeaderboard';
import classes from './PopupLeaderboard.module.css';

import SoundPlayer from 'react-sdk/SoundPlayer';
import Texts from 'react-sdk/Texts';
import Button from '@/components/shared/Button/Button';
import clsx from 'clsx';

const PopupLeaderboard = () => {

  const [tabindex, setTabindex] = useState(0);

  useEffect(() => {
    let currentMusic = SoundPlayer.currentId
    SoundPlayer.playSound("music_leaderboard")

    return () => {
      SoundPlayer.playSound(currentMusic)
    }
  }, []);

  function handleClose() {
    PopupsManager.close(POPUPS.LEADERBOARD)
  }

  function tabClicked(index) {
    setTabindex(index)
  }

  return (

    <Popup className={classes.PopupLeaderboard} >
      <div className={classes.PopupHeader}>
        <div className={classes.PopupTitle} dangerouslySetInnerHTML={{__html: "Classement"}} />
        <div className={classes.PopupSubTitle} dangerouslySetInnerHTML={{__html: tabindex == 0 ? "des joueurs" : "des équipes"}} />
      </div>
      
      <div className={classes.chars_ctnr} >
        <img className={clsx(classes.chars, tabindex == 0 && classes.zoomed)} src={"data/images/LP_persos.png"} /> 
      </div>


      <div className={classes.PopupContent} >
        <Tabs
          onTabClick={tabClicked}
          popupId={POPUPS.LEADERBOARD}
          tabs={["Joueurs"/* , "Equipes" */]}
          panels={[<PagePlayerLeaderboard />/* , <PageTeamLeaderboard /> */]}
        />
      </div>

      <div className={classes.btn_ctnr}>
          <Button onClick={handleClose}>
            Continuer
          </Button>
        </div>


    </Popup>

  );
};

export default PopupLeaderboard;
